package org.multiplatform.kotfolio.pages.kotlin.new_feature

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kotlin/new_feature/2.3.20")
@Composable
fun NewFeature_2_3_20Page() {
    BlogLayout(
        PageProperties(
            "Kotlin 2.3.20",
            ""
        ),
        BlogProperties("kotlin", "Kotlin 2.3.20")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Name-based destructuring",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                        kotlin {
                            compilerOptions {
                                freeCompilerArgs.add("-Xname-based-destructuring=only-syntax")
                            }
                        }
                        
                        //destructuring declarations used position-based 
                        data class User(val username: String, val email: String)

                        fun main() {
                            val user = User("kamlesh", "kamal.lakhani56@gmail.co")

                            val (email, username) = user

                            println(email)
                            println(username)
                        }
                        
                        //name-based destructuring declarations
                        fun main() {
                            val user = User("kamlesh", "kamal.lakhani56@gmail.com")

                            // Uses name-based destructuring with explicit form
                            (val mail = email, val name = username) = user

                            println(name)
                            println(mail)
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                        //immutable copies of Map.Entry
                        
                        @OptIn(ExperimentalStdlibApi::class)
                        fun main() {
                            val map = mutableMapOf(1 to 1, 2 to 2, 3 to 3, 4 to 4)

                            val toRemove = map.entries
                                .filter { it.key % 2 == 0 }
                                .map { it.copy() }

                            map.entries.removeAll(toRemove)

                            println("map = $map")
                            // map = {1=1, 3=3}
                        }
                    """.trimIndent()
            )
        }
    }
}

//https://www.youtube.com/watch?v=PU-VdH8HhVA